import * as React from 'react'
import { ComponentType } from 'react'
import { connect } from 'react-redux'

import type { StateTransform } from '@src/index'

import { orgGatewayResolver } from '../services/org-gateway-resolver'
import { AdminShell } from './AdminShell'

type StateProps = {
  organizationId: string | null
}

type HostOwnProps = {
  children: React.ReactNode
}

const AdminRouteHostComponent: React.FC<StateProps & HostOwnProps> = ({ organizationId, children }) => (
  <AdminShell organizationId={organizationId} resolver={orgGatewayResolver}>
    {children}
  </AdminShell>
)

const mapStateToProps: StateTransform<StateProps> = (s) => ({
  organizationId: s.organization?.currentOrganization?.id ?? null,
})

export const AdminRouteHost = connect(mapStateToProps)(AdminRouteHostComponent)

/**
 * HOC that wraps a page component in `AdminRouteHost` so route definitions can
 * reference a single ComponentType rather than having to inline JSX.
 */
export function withAdminShell<P extends object>(Page: ComponentType<P>): ComponentType<P> {
  const Wrapped: React.FC<P> = (props) => (
    <AdminRouteHost>
      <Page {...(props as P)} />
    </AdminRouteHost>
  )
  Wrapped.displayName = `withAdminShell(${Page.displayName ?? Page.name ?? 'Component'})`
  return Wrapped
}
